import Vue from 'vue';
import i18n from '../../shared/i18n';

const ErrorDialog = {
  install(vue) {
    vue.prototype.$errorDialog = function (message, title = i18n.t('Error'), options = {}) {
      const h = this.$createElement;
      // More complex structure
      const messageVNode = h('div', {class: ['d-flex align-items-center']}, [
        h('p', {class: ['mb-0'], style: 'font-size: 16px; line-height: 23px'}, [message]),
      ]);


      return this.$bvModal.msgBoxOk(messageVNode, {
        id: 'error-dialog',
        title: title,
        okVariant: 'danger',
        okTitle: 'OK',
        cancelTitle: 'NO',
        headerClass: 'py-2 px-3',
        footerClass: 'py-2 px-3',
        hideHeaderClose: true,
        centered: true,
        headerBgVariant: 'danger',
        headerTextVariant: 'light',
        // footerBgVariant: 'danger',
        // footerTextVariant: 'light'
        ...options,
      });
    };
  },
};

Vue.use(ErrorDialog);
